/* ============================================================================
   lma-buybox-top.js
   Behaviour of the server rendered buy box top, snippet snippets/lma-buybox-top.liquid.
   Luveon US, product page, EVERYTHING ABOVE THE ADD TO CART BUTTON.

   WHY THIS FILE EXISTS INSTEAD OF A <script> BLOCK IN THE SNIPPET
   A snippet has neither {% schema %}, nor {% stylesheet %}, nor {% javascript %}.
   Its CSS and its script live in assets/. An inline block would also run twice on
   any page that renders the snippet twice.

   FIVE JOBS, AND NOTHING ELSE
     1. Mark the info container with .lma-bbt-on, the fallback that hides the
        replaced theme nodes in browsers without :has().
     2. Hide the theme price node this block replaces, and only the candidates
        that strictly precede the add to cart button.
     3. Place the bundle furniture of the imposed list part 2: the subtitle
        "One to wear, one to wash" and the unit price badge inside the featured
        tier, the TODAY ONLY label on the tier badge, and the dated urgency line,
        the honest countdown and the risk free reassurance right under the offers.
     4. Run the countdown. It targets midnight of the CURRENT day in the timezone
        of the visitor. No localStorage, no cookie, no fixed duration: nothing is
        stored, so nothing can restart at each visit.
     5. Translate the French option labels FOR DISPLAY ONLY.

   THE FOUR HARD RULES WRITTEN INTO THE CODE BELOW
     A. FRONTIER. .lma-bundle__submit is the floor. Every node this file reads,
        hides, moves or writes is tested with strictlyPrecedes() against that
        button first. An ancestor of the button is rejected too, which is what
        stops a hiding rule from taking the button down with it.
     B. VARIANT SAFETY. Translation touches visible text, title and aria-label
        only. Never an option value, never an input value, never a data attribute.
        Matching is on the exact trimmed string, never by inclusion, so
        "Bleu Marine" can never become "Blue Marine". A colour missing from the
        table stays in French on purpose: a visible gap beats a guessed word.
     C. NO SILENT HALF STATE. Nothing is ever hidden while waiting for this file.
        The snippet is printed complete by the server, so a blocked script, an
        extension or a syntax error leaves the buy box visible, complete and
        buyable. The only thing lost is the placement, never the facts: the
        sentence in .lma-bbt__fallback carries all of part 2 and is removed only
        once the real nodes have actually been placed.
     D. IDEMPOTENCE. Loaded twice, the second copy exits. Re-run after a variant
        re-render, it only puts back what the re-render wiped out.
   ============================================================================ */

(function () {
  'use strict';

  /* Loaded twice: the second copy stops here. */
  if (window.LMA_BBT_LOADED) { return; }
  window.LMA_BBT_LOADED = true;

  var NS = '[lma-buybox-top]';
  var warned = false;

  function warn(message) {
    if (warned) { return; }
    warned = true;
    if (window.console && console.warn) { console.warn(NS + ' ' + message); }
  }

  /* Libelles traduits, 2026-09-11. Le snippet les publie dans window.LuveonI18n
     (cle | t | json) avant de charger ce fichier ; le texte anglais d origine
     sert de repli si l objet ou la cle manquent. __N__ est le numero de l avis. */
  function reviewDotLabel(n) {
    var i18n = window.LuveonI18n || {},
        pattern = (typeof i18n.buybox_review_dot_aria === 'string' && i18n.buybox_review_dot_aria) ? i18n.buybox_review_dot_aria : 'Review __N__';
    if (pattern.indexOf('__N__') === -1) { return pattern + ' ' + n; }
    return pattern.replace('__N__', String(n));
  }

  /* ==========================================================================
     THE FRONTIER. True only when node comes strictly before the boundary and is
     not one of its ancestors. Rejecting ancestors is not a detail: without it,
     hiding a node that wraps the add to cart button would take the button away
     and the page would stay pretty and stop selling.
     ========================================================================== */
  function strictlyPrecedes(node, boundary) {
    if (!node || !boundary) { return false; }
    var pos = boundary.compareDocumentPosition(node);
    return !!(pos & Node.DOCUMENT_POSITION_PRECEDING) && !(pos & Node.DOCUMENT_POSITION_CONTAINS);
  }

  /* ==========================================================================
     DISPLAY ONLY TRANSLATION
     ========================================================================== */

  /* Object.create(null), never {}. A plain object answers map["constructor"] with
     an inherited function, which is truthy, and the swap would write a function
     into a text node. */
  function parseMap(raw) {
    var map = Object.create(null), rows, i, eq, from, to;
    if (!raw) { return map; }
    rows = raw.split('|');
    for (i = 0; i < rows.length; i++) {
      eq = rows[i].indexOf('=');
      if (eq < 1) { continue; }
      from = rows[i].slice(0, eq).trim();
      to = rows[i].slice(eq + 1).trim();
      if (from && to && from !== to) { map[from] = to; }
    }
    return map;
  }

  function swapText(el, map) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null),
        hits = [], node, i, raw, lead, trail, core, next;
    while ((node = walker.nextNode())) { hits.push(node); }
    for (i = 0; i < hits.length; i++) {
      raw = hits[i].nodeValue || '';
      lead = /^\s*/.exec(raw)[0];
      /* \s already covers the non breaking space a French label puts before a colon. */
      trail = /[\s:,]*$/.exec(raw)[0];
      if (lead.length + trail.length >= raw.length) { continue; }
      core = raw.slice(lead.length, raw.length - trail.length);
      next = map[core];
      if (typeof next === 'string') { hits[i].nodeValue = lead + next + trail; }
    }
  }

  function swapAttrs(el, map) {
    /* title and aria-label only. Never value, never a data attribute. */
    var names = ['title', 'aria-label'], i, raw, next;
    for (i = 0; i < names.length; i++) {
      if (!el.hasAttribute(names[i])) { continue; }
      raw = el.getAttribute(names[i]);
      next = map[(raw || '').trim()];
      if (typeof next === 'string') { el.setAttribute(names[i], next); }
    }
  }

  function translate(container, boundary, map) {
    var targets = container.querySelectorAll(
          'select.lma-bundle__size option, .lma-bundle__swatch, .lma-bundle__option-label, ' +
          '.lma-bundle__variant-row, label, optgroup[label]'
        ),
        i, el;
    for (i = 0; i < targets.length; i++) {
      el = targets[i];
      if (el.closest('.lma-bbt') || el.closest('.lma-bbt-u') || el.closest('.lma-bbt-t')) { continue; }
      if (!strictlyPrecedes(el, boundary)) { continue; }
      swapText(el, map);
      swapAttrs(el, map);
      /* optgroup carries its visible text in an attribute. It is a label, not a value. */
      if (el.tagName === 'OPTGROUP' && el.hasAttribute('label')) {
        var g = map[(el.getAttribute('label') || '').trim()];
        if (typeof g === 'string') { el.setAttribute('label', g); }
      }
    }
  }

  /* ==========================================================================
     THEME PRICE NODE. The class of the 44.90 node was not recorded in _FACTS.md,
     so the selector list is a list of candidates. That is exactly why the hiding
     is done here and not in CSS: every candidate is tested against the position
     of the add to cart button, so a broad selector such as .price can never
     reach the button, the cart form or anything below them.
     ========================================================================== */
  function hideThemePrice(container, boundary, selector) {
    var nodes, i, node;
    if (!selector) { return; }
    try { nodes = container.querySelectorAll(selector); } catch (e) { warn('bad price selector'); return; }
    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (node.closest('.lma-bbt') || node.closest('.lma-bbt-u') || node.closest('.lma-bbt-t')) { continue; }
      if (node.closest('.lma-bundle__offers')) { continue; }
      if (node.contains(boundary)) { continue; }
      if (!strictlyPrecedes(node, boundary)) { continue; }
      if (node.hasAttribute('data-lma-bbt-hid')) { continue; }
      node.setAttribute('data-lma-bbt-hid', '1');
      node.style.display = 'none';
    }
  }

  /* ==========================================================================
     BUNDLE FURNITURE, imposed list part 2. Placement only: every string is
     printed by the server, this file never writes copy.
     ========================================================================== */

  function featuredTier(offers) {
    var list = offers.querySelectorAll('.lma-bundle__offer'), i;
    if (!list.length) { return null; }
    /* The featured tier is the one that carries the badge, not the one that
       carries .is-selected: the theme moves .is-selected as soon as the visitor
       clicks the other tier, and the unit price badge would follow it onto the
       single tier, where it would be false. */
    for (i = 0; i < list.length; i++) { if (list[i].querySelector('.lma-bundle__badge')) { return list[i]; } }
    for (i = 0; i < list.length; i++) { if (list[i].querySelector('s')) { return list[i]; } }
    return list[list.length - 1];
  }

  function placeFurniture(state) {
    var container = state.container,
        boundary = state.boundary,
        offers = container.querySelector('.lma-bundle__offers'),
        tier, badge, label, node, placedTier = false, placedUrgency = false;

    /* Le bloc d urgence est facultatif depuis le 2026-08-25. Son absence ne doit
       PAS empecher la pose du mobilier de palier : sortir ici priverait le
       palier retenu de sa pastille de remise et de sa ligne de reassurance. */
    if (!offers || !offers.parentNode || !strictlyPrecedes(offers, boundary)) { return false; }

    /* Rule 2.1 of the imposed list: two tiers, never three. We never add one, and
       if the theme ever shows a count other than two we do not guess which tier
       carries the offer: the tier inset is skipped and the sentence fallback
       stays on the page. */
    /* Titre entre filets, au-dessus des deux offres.

       Le test de presence porte sur le PARENT DES OFFRES et non sur tout le
       conteneur : la source du titre vit dans la racine [data-lma-bbt], elle
       meme dans ce conteneur, donc un querySelector large la trouvait toujours,
       la condition etait toujours fausse et le titre n etait jamais pose.
       Constate au rendu le 2026-08-25 : le bloc restait masque dans la racine.
       On clone en outre le paragraphe et non le pack, pour ne pas transporter
       l attribut hidden. */
    if (state.bundleHeadPack) {
      var headSrc = state.bundleHeadPack.querySelector('.lma-bbt-bh');
      if (headSrc && !offers.parentNode.querySelector('.lma-bbt-bh')) {
        offers.parentNode.insertBefore(headSrc.cloneNode(true), offers);
      }
    }

    var count = offers.querySelectorAll('.lma-bundle__offer').length;
    if (count === 2 && state.tierPack) {
      tier = featuredTier(offers);
      if (tier && strictlyPrecedes(tier, boundary)) {
        if (!tier.querySelector('.lma-bbt-t')) {
          node = state.tierPack.cloneNode(true);
          node.removeAttribute('hidden');
          /* Sous le NOM de l offre et non en pied de palier : la sous-ligne et le
             prix unitaire appartiennent au titre, comme chez Silix, et non a la
             zone des variantes. Insere apres l entete, donc avant le guide des
             tailles et les rangees de couleur. */
          var head = tier.querySelector('.lma-bundle__offer-heading');
          if (head && head.parentNode) { head.parentNode.insertBefore(node, head.nextSibling); }
          else { tier.appendChild(node); }
        }
        placedTier = true;

        /* Pastille de remise sur le nom du palier, facon Silix.

           Elle va DANS le noeud du nom, pas a cote : l entete du palier est une
           grille, et un frere supplementaire y ouvre une cellule de plus, ce qui
           renvoyait le prix a la ligne suivante (constate au rendu le
           2026-08-25). A l interieur du nom, elle suit le texte et la grille
           garde ses trois colonnes. Le nom n est pas reecrit par le theme, qui
           ne pilote que les noeuds a attribut data-*, donc la pastille tient. */
        if (state.tierBadgePack && !tier.querySelector('.lma-bbt-tb')) {
          var nameNode = tier.querySelector('.lma-bundle__name');
          var badgeSrc = state.tierBadgePack.querySelector('.lma-bbt-tb');
          if (nameNode && badgeSrc) {
            nameNode.appendChild(badgeSrc.cloneNode(true));
          }
        }

        /* TODAY ONLY on the existing tier badge. Text only, on a label node that
           carries no price and no value. The original text is kept on the node so
           the change can be read and undone by hand. */
        /* L onglet du palier porte le libelle ET son minuteur, comme chez Silix.
           Le texte d origine est conserve en attribut pour pouvoir revenir en
           arriere a la main. */
        badge = tier.querySelector('.lma-bundle__badge');
        if (badge && state.tabPack && !badge.querySelector('.lma-bbt-tab')) {
          if (!badge.hasAttribute('data-lma-bbt-was')) {
            badge.setAttribute('data-lma-bbt-was', badge.textContent.trim());
          }
          var tabNode = state.tabPack.querySelector('.lma-bbt-tab');
          if (tabNode) {
            badge.textContent = '';
            badge.appendChild(tabNode.cloneNode(true));
            startTabClock(container);
          }
        }
      }
    } else if (count && count !== 2) {
      warn('the offers block shows ' + count + ' tiers instead of 2, tier inset skipped');
    }

    /* The urgency line, the countdown and the risk free reassurance, glued under
       the offers block. offers.nextSibling can be the add to cart button itself:
       inserting before it still lands above it, which is the whole point. */
    if (state.urgencyPack && !container.querySelector('.lma-bbt-u')) {
      node = state.urgencyPack.cloneNode(true);
      node.removeAttribute('hidden');
      offers.parentNode.insertBefore(node, offers.nextSibling);
    }
    placedUrgency = !!container.querySelector('.lma-bbt-u');
    if (placedUrgency) { startClock(container); }

    /* The sentence fallback goes only once the real nodes are in place. */
    /* La phrase de repli disparait des que le mobilier ATTENDU est en place.
       Sans bloc d urgence, attendre placedUrgency laisserait la phrase de repli
       a l ecran pour toujours : c est le palier qui fait foi dans ce cas. */
    var furnitureReady = placedTier && (placedUrgency || !state.urgencyPack);
    if (furnitureReady && state.fallback && state.fallback.parentNode) {
      state.fallback.parentNode.removeChild(state.fallback);
      state.fallback = null;
    }
    return placedTier || placedUrgency;
  }

  /* ==========================================================================
     THE HONEST COUNTDOWN. Target: midnight of the current day, in the timezone of
     the visitor. setHours(24, 0, 0, 0) is the end of today, so at midnight the
     counter leaves for 23:59:59 because the day has changed. That keeps the
     sentence "ends at midnight tonight" true every day and false on none.
     Nothing is stored, so nothing restarts at each visit.
     ========================================================================== */

  var timer = null;

  function two(n) { return (n < 10 ? '0' : '') + n; }

  /* Deux modes, choisis par l attribut data-lma-bbt-countdown sur la racine.

     "midnight"  vise minuit du jour courant. Rien n est stocke, donc rien ne
                 peut redemarrer : la phrase reste vraie tous les jours.
     "<minutes>" un nombre lance un minuteur de cette duree, RELANCE A CHAQUE
                 VISITE. C est le procede de Silix, choisi par Pierre le
                 2026-08-24 contre l avis donne. A savoir : un compte a rebours
                 qui repart a chaque visite est une urgence fabriquee, et la FTC
                 a deja sanctionne ce procede aux Etats-Unis. Repasser en mode
                 honnete est une seule valeur a changer dans le reglage.
  */
  /* Le mode voyage avec le noeud. placeFurniture CLONE le pack d urgence et le
     depose sous .lma-bundle__offers, donc HORS de la racine [data-lma-bbt] :
     un closest('[data-lma-bbt]') depuis l horloge clonee renvoyait null, le mode
     retombait sur 'midnight' et le compteur affichait le temps restant avant
     minuit au lieu des 30 minutes reglees. Constate au rendu le 2026-08-25
     (13:52:15 affiche a 10h08). On resout donc le mode par l attribut porte par
     le pack lui meme, avec la racine en second recours. */
  var clockEnd = null;

  function resolveMode(node) {
    var host = node && node.closest('[data-lma-bbt-countdown]');
    if (host) { return host.getAttribute('data-lma-bbt-countdown') || 'midnight'; }
    var root = document.querySelector('[data-lma-bbt]');
    return (root && root.getAttribute('data-lma-bbt-countdown')) || 'midnight';
  }

  function paint(node) {
    var mode = resolveMode(node);
    var left;
    var minutes = parseInt(mode, 10);
    if (!isNaN(minutes) && minutes > 0) {
      /* L echeance vit au niveau du module, pas sur le noeud : le theme re-rend
         le bloc d offres a chaque changement de variante et un nouveau clone
         aurait relance le compteur a 30:00 sous les yeux du visiteur. Un seul
         redemarrage, au chargement de la page, comme decide. */
      if (!clockEnd || clockEnd - Date.now() <= 0) { clockEnd = Date.now() + minutes * 60000; }
      left = Math.floor((clockEnd - Date.now()) / 1000);
    } else {
      var end = new Date();
      end.setHours(24, 0, 0, 0);
      left = Math.floor((end.getTime() - Date.now()) / 1000);
    }
    if (left < 0) { left = 0; }
    node.textContent = two(Math.floor(left / 3600)) + ':' +
                       two(Math.floor((left % 3600) / 60)) + ':' +
                       two(left % 60);
  }

  /* Horloge de l onglet, en minutes:secondes. Elle a son propre compte, distinct
     de celui du bloc d urgence : Pierre la veut demarree a 29:43 et non a 30:00.
     L echeance vit au niveau du module pour que le compteur ne reparte pas a
     chaque fois que le theme re-rend le bloc d offres. */
  var tabEnd = null, tabTimer = null;

  function paintMmss(node) {
    var total = parseInt(node.getAttribute('data-lma-bbt-mmss'), 10);
    if (isNaN(total) || total <= 0) { total = 1800; }
    if (!tabEnd || tabEnd - Date.now() <= 0) { tabEnd = Date.now() + total * 1000; }
    var left = Math.floor((tabEnd - Date.now()) / 1000);
    if (left < 0) { left = 0; }
    node.textContent = two(Math.floor(left / 60)) + ':' + two(left % 60);
  }

  function startTabClock(container) {
    var node = container.querySelector('[data-lma-bbt-mmss]');
    if (!node) { return; }
    paintMmss(node);
    if (tabTimer) { return; }
    tabTimer = window.setInterval(function () {
      var live = document.querySelector('[data-lma-bbt-mmss]');
      if (!live) { window.clearInterval(tabTimer); tabTimer = null; return; }
      paintMmss(live);
    }, 1000);
  }

  function startClock(container) {
    var node = container.querySelector('[data-lma-bbt-clock]');
    if (!node) { return; }
    node.removeAttribute('hidden');
    paint(node);
    if (timer) { return; }
    timer = window.setInterval(function () {
      var live = document.querySelector('[data-lma-bbt-clock]');
      if (!live) { window.clearInterval(timer); timer = null; return; }
      paint(live);
    }, 1000);
  }


  /* ==========================================================================
     CARROUSEL D AVIS. Le defilement lui-meme est natif (scroll-snap) : ce qui
     suit n ajoute que les points de navigation et une rotation automatique.
     Si ce module ne tourne pas, l encart reste lisible et defilable au doigt.
     ========================================================================== */

  function setupReviews(root) {
    var box = root.querySelector('[data-lma-bbt-rv]');
    if (!box || box.hasAttribute('data-lma-bbt-rv-done')) { return; }
    var track = box.querySelector('[data-lma-bbt-rv-track]');
    var dots = box.querySelector('[data-lma-bbt-rv-dots]');
    if (!track || !dots) { return; }
    var cards = track.children;
    if (cards.length < 2) { return; }
    box.setAttribute('data-lma-bbt-rv-done', '1');

    var current = 0, timer = null, paused = false, buttons = [];

    /* scrollTo({behavior:'smooth'}) est annule par scroll-snap-type: mandatory :
       le point actif changeait mais la piste ne bougeait pas d un pixel, verifie
       au rendu le 2026-08-25 sur page neuve. L affectation directe de scrollLeft
       fonctionne, et l animation reste douce parce que la feuille de style porte
       deja scroll-behavior: smooth sur la piste. */
    var moving = null, raf = null, safety = null;
    var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Animation ecrite a la main, au minuteur.

       Trois methodes natives ont ete essayees et echouent toutes ici, annulees
       par scroll-snap-type: mandatory : scrollTo({behavior:'smooth'}),
       scrollIntoView({behavior:'smooth'}) et la propriete CSS scroll-behavior.
       Seule l ecriture directe de scrollLeft deplace la piste.
       Le minuteur est prefere a requestAnimationFrame parce que RAF est suspendu
       des que l onglet passe en arriere-plan : la piste resterait alors figee
       entre deux avis, a mi-chemin. Avec un minuteur, la position finale est
       toujours atteinte. */
    function animateTo(target) {
      if (raf) { window.clearInterval(raf); raf = null; }
      var from = track.scrollLeft, delta = target - from;
      if (noMotion || Math.abs(delta) < 2) { track.scrollLeft = target; moving = null; return; }
      var dur = 380, step = 16, elapsed = 0;

      function land() {
        if (raf) { window.clearInterval(raf); raf = null; }
        if (safety) { window.clearTimeout(safety); safety = null; }
        track.scrollLeft = target;
        moving = null;
      }

      raf = window.setInterval(function () {
        elapsed += step;
        var p = Math.min(1, elapsed / dur);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = from + delta * e;
        if (p >= 1) { land(); }
      }, step);

      /* Filet : un navigateur qui met l onglet en veille ralentit fortement les
         minuteurs, et l animation pourrait s arreter entre deux avis. Ce rendez
         vous unique repose la position finale quoi qu il arrive. */
      safety = window.setTimeout(land, dur + 220);
    }

    function go(i) {
      current = (i + cards.length) % cards.length;
      /* Les evenements de defilement emis PENDANT l animation ne doivent pas
         etre lus comme un geste du visiteur, sinon la position calculee en cours
         de route ecrase la destination. */
      moving = true;
      animateTo(cards[current].offsetLeft - track.offsetLeft);
      paint();
    }

    function paint() {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-current', i === current ? 'true' : 'false');
      }
    }

    /* La carte ouvre la fenetre. Le clic n est pris que si le doigt n a pas
       fait defiler : sur un carrousel tactile, un balayage se termine par un
       clic sur la carte et ouvrirait la fenetre a chaque glissement. */
    var downX = 0, downY = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; }, { passive: true });
    track.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) { moved = true; }
    }, { passive: true });

    var modal = root.querySelector('[data-lma-rv-modal]');
    var lastFocus = null;

    /* La fenetre est deplacee a la racine du document. Elle nait dans la colonne
       d infos, qui porte position:sticky : un ancetre positionne cree un
       contexte d empilement, et un position:fixed s y ancre au lieu de couvrir
       l ecran. Constate au rendu le 2026-08-25, la fenetre s ouvrait a mi-page
       et le voile ne couvrait rien. */
    if (modal && modal.parentNode !== document.body) { document.body.appendChild(modal); }

    function closeModal() {
      if (!modal) { return; }
      modal.setAttribute('hidden', '');
      document.body.classList.remove('lma-rvm-open');
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    function openModal(index) {
      if (!modal) { return; }
      var items = modal.querySelectorAll('[data-lma-rv-item]');
      for (var n = 0; n < items.length; n++) {
        if (items[n].getAttribute('data-lma-rv-item') === String(index)) { items[n].removeAttribute('hidden'); }
        else { items[n].setAttribute('hidden', ''); }
      }
      /* Une image en chargement differe placee dans un conteneur masque n est
         jamais demandee par le navigateur : la photo restait a zero de hauteur
         a l ouverture. On bascule celle de l avis affiche en chargement
         immediat au moment ou la fenetre s ouvre, et elle seule. */
      var shown = modal.querySelector('[data-lma-rv-item]:not([hidden]) .lma-rvm__photo');
      if (shown && shown.loading === 'lazy') { shown.loading = 'eager'; }

      lastFocus = document.activeElement;
      modal.removeAttribute('hidden');
      document.body.classList.add('lma-rvm-open');
      var panel = modal.querySelector('.lma-rvm__panel');
      if (panel) { panel.scrollTop = 0; }
      var close = modal.querySelector('[data-lma-rv-close]');
      if (close && close.focus) { close.focus(); }
    }

    track.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('[data-lma-rv-open]') : null;
      if (!card) { return; }
      if (moved) { moved = false; return; }
      openModal(card.getAttribute('data-lma-rv-open'));
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-lma-rv-close]')) { closeModal(); return; }
        /* Clic hors du panneau : le voile n est plus un noeud a viser, c est la
           fenetre elle-meme qui le peint. On ferme donc quand le clic tombe a
           cote du panneau. */
        if (e.target === modal) { closeModal(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hasAttribute('hidden')) { closeModal(); }
      });
    }

    for (var i = 0; i < cards.length; i++) {
      (function (index) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lma-bbt-rv__dot';
        b.setAttribute('aria-label', reviewDotLabel(index + 1));
        b.addEventListener('click', function () { paused = true; go(index); });
        dots.appendChild(b);
        buttons.push(b);
      })(i);
    }
    paint();

    /* Le defilement au doigt fait autorite sur la rotation : des que le visiteur
       fait defiler lui-meme, on suit sa position et on cesse d avancer seul. */
    var settle = null;
    track.addEventListener('scroll', function () {
      if (moving) { return; }
      paused = true;
      if (settle) { window.clearTimeout(settle); }
      settle = window.setTimeout(function () {
        var best = 0, gap = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < gap) { gap = d; best = i; }
        }
        current = best;
        paint();
      }, 120);
    }, { passive: true });

    if (!noMotion) {
      timer = window.setInterval(function () {
        if (paused || !box.isConnected) { return; }
        go(current + 1);
      }, 5000);
    }
  }

  /* ==========================================================================
     BOOT
     ========================================================================== */

  function run(state) {
    if (state.busy) { return; }
    state.busy = true;
    try {
      if (state.boundary && !state.boundary.isConnected) { state.boundary = null; }
      if (!state.boundary) { state.boundary = state.container.querySelector('.lma-bundle__submit'); }
      if (!state.boundary) {
        /* No add to cart button means no frontier to check against. Nothing that
           touches a theme node runs. The block itself stays fully visible. */
        warn('add to cart button .lma-bundle__submit not found, theme nodes left untouched');
        state.busy = false;
        return;
      }
      hideThemePrice(state.container, state.boundary, state.priceSelector);
      placeFurniture(state);
      if (state.map) { translate(state.container, state.boundary, state.map); }
    } catch (error) {
      warn('run failed, ' + (error && error.message ? error.message : 'unknown error'));
    }
    state.busy = false;
  }

  function setup(root) {
    if (root.hasAttribute('data-lma-bbt-done')) { return; }
    root.setAttribute('data-lma-bbt-done', '1');

    var container = root.closest('.product__info-container') || root.parentElement;
    if (!container) { return; }
    container.classList.add('lma-bbt-on');
    try { setupReviews(root); } catch (e) { warn('reviews carousel failed, ' + (e && e.message ? e.message : 'unknown')); }

    /* show_bundle_furniture can be off at the render call. Missing furniture is
       not a reason to drop the translation and the price hiding, so it is noted
       and the rest of the work goes on. */
    var tierPack = root.querySelector('[data-lma-bbt-tier]');
    var urgencyPack = root.querySelector('[data-lma-bbt-urgency]');
    var tierBadgePack = root.querySelector('[data-lma-bbt-tierbadge]');
    var bundleHeadPack = root.querySelector('[data-lma-bbt-bundlehead]');
    var tabPack = root.querySelector('[data-lma-bbt-tab]');

    var state = {
      container: container,
      boundary: null,
      busy: false,
      /* Detached snapshots. The theme re-renders the offers block on every variant
         change and takes our nodes down with it, so we re-insert a copy instead of
         hunting for the originals. */
      tierPack: tierPack ? tierPack.cloneNode(true) : null,
      tierBadgePack: tierBadgePack ? tierBadgePack.cloneNode(true) : null,
      bundleHeadPack: bundleHeadPack ? bundleHeadPack.cloneNode(true) : null,
      tabPack: tabPack ? tabPack.cloneNode(true) : null,
      urgencyPack: urgencyPack ? urgencyPack.cloneNode(true) : null,
      fallback: root.querySelector('.lma-bbt__fallback'),
      todayLabel: root.getAttribute('data-lma-bbt-today') || '',
      priceSelector: root.getAttribute('data-lma-bbt-pricesel') || '',
      map: null
    };

    /* Garde ajoutee le 2026-08-24 : le commentaire six lignes plus haut dit que
   l absence de mobilier ne doit PAS faire tomber la traduction ni le
   masquage du prix, mais le code dereferencait tierPack sans garde. Un
   rendu sans mobilier levait donc "Cannot read properties of null" et tout
   le reste du travail etait perdu. Mesure sur la PDP du legging. */
    if (tierPack && tierPack.parentNode) { tierPack.parentNode.removeChild(tierPack); }
    if (urgencyPack && urgencyPack.parentNode) { urgencyPack.parentNode.removeChild(urgencyPack); }

    if (root.hasAttribute('data-lma-bbt-colormap')) {
      state.map = parseMap(root.getAttribute('data-lma-bbt-colormap'));
      var labels = parseMap(root.getAttribute('data-lma-bbt-labelmap'));
      Object.keys(labels).forEach(function (key) { state.map[key] = labels[key]; });
    }

    run(state);

    /* The observer is bound to the buy box container, never to document.body, and
       it is inert while we are the ones mutating. It converges: a second pass
       finds our nodes in place and translated strings that match nothing. */
    if ('MutationObserver' in window) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (state.busy || scheduled) { return; }
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; run(state); });
      });
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lma-bbt]'), i;
    for (i = 0; i < roots.length; i++) {
      try { setup(roots[i]); } catch (error) {
        warn('setup failed, ' + (error && error.message ? error.message : 'unknown error'));
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
